export default __webpack_public_path__ + "static/media/bus-trv-7.661c78bc.png";